import camelcaseKeys from 'camelcase-keys';
import env from '@beam-australia/react-env';
import { selectFingerprint } from 'src/modules/User';
import getApiUrl from 'src/config/api';

function getSocketUrl() {
    const socketUrl = env('SOCKET_URL');

    if (!socketUrl) {
        const apiUrl = getApiUrl();
        return apiUrl.replace('http', 'ws');
    }

    return socketUrl;
}

class WebSocket {
    options = {
        actionName: '',
        tryOpenCount: 10,
        tryOpenTimeout: 250,
        ping: 1000,
        getSocketUrl,
        userSelector: () => '',
        reconnect: true
    }

    socket = {
        connection: null,
        opened: false
    }

    dispatch = undefined;

    constructor(options) {
        window.WebSocket = window.WebSocket || window.MozWebSocket;

        this.options = {
            ...this.options,
            ...options
        };
    }

    connect = (dispatch, getState, actionName) => {
        if (!dispatch) {
            console.error('dispatch parameter is required'); // eslint-disable-line
        }

        if (!getState) {
            console.error('getState parameter is required'); // eslint-disable-line
        }

        if (!this.receive) {
            console.error('receive method is undefined, implement receive method to get data from socket!'); // eslint-disable-line
        }

        if (!this.options.getSocketUrl()) {
            console.error('socket url is undefined. Pass url param in socket options to set url.'); // eslint-disable-line
        }

        this.dispatch = dispatch;
        this.getState = getState;
        this.actionName = actionName;

        const fingerprint = selectFingerprint(getState());

        this.socket.connection = new window.WebSocket(`${this.options.getSocketUrl()}/${actionName
             || this.options.actionName}?authorization=${fingerprint}`);
        this.socket.connection.onopen = this.onOpen;
        this.socket.connection.onerror = this.onError;
        this.socket.connection.onmessage = this.onMessage;
        this.socket.connection.onclose = this.onClose;
    }

    close() {
        this.socket.opened = false;
        this.socket.connection.close();
    }

    onClose = () => {
        if (this.socket.opened && this.options.reconnect) {
            setTimeout(() => {
                this.connect(this.dispatch, this.getState, this.actionName);
            }, 2000);
        }
    }

    onOpen = async () => {
        // const authToken = this.options.userSelector(this.getState()) || {};

        // await this.send(authToken, { force: true, type: 'plain' });

        this.socket.opened = true;
    }

    onError = (event) => {
        // eslint-disable-next-line no-console
        console.warn(event);
    }

    onMessage = (message) => {
        if (message.data === 'Ping') {
            this.pong();

            return;
        }

        try {
            const json = JSON.parse(message.data);
            this.receive(camelcaseKeys(json, { deep: true }));
        } catch (e) {
            this.receive(message.data);
        }
    }

    async send(message, options = {}) {
        if (!options.force) {
            const isOpened = await this.waitForOpen();

            if (!isOpened) {
                return;
            }
        }

        if (options.type === 'plain') {
            this.socket.connection.send(message);
        } else {
            const jsonMessage = JSON.stringify(message);
            this.socket.connection.send(jsonMessage);
        }
    }

    wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

    async waitForOpen() {
        // eslint-disable-next-line no-async-promise-executor
        const promise = new Promise(async (resolve) => {
            for (let i = 0; i < this.options.tryOpenCount; i += 1) {
                await this.wait(this.options.tryOpenTimeout); // eslint-disable-line

                if (this.socket.opened) {
                    resolve(this.socket.opened);
                    break;
                }
            }
        });

        return promise.then((openState) => openState && this.socket.connection.readyState === 1);
    }

    async pong() {
        const authToken = this.options.userSelector(this.getState()) || {};

        await this.send(authToken, { type: 'plain' });
    }
}

export default WebSocket;
